export default {
  apiVersion: 2,
  development: {
    accessToken: '9abb4be373681d83e787c3c0625b4366',
    url: 'http://beituskurinn.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '9abb4be373681d83e787c3c0625b4366',
    url: 'https://api.beituskurinn.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '9abb4be373681d83e787c3c0625b4366',
    url: 'https://api.beituskurinn.is/_/moya/pilot/api',
  },
};
